/**  最小化应用 */
const MINIUMIZE = 'miniumize';
/** 退出应用 */
const QUIT = 'quit';

export function useElectron() {
  const isElectron =
    typeof process !== 'undefined' && process?.server
      ? false
      : navigator?.userAgent.toLowerCase().indexOf('electron/') > -1;
  return {
    isElectron,
    minimumize() {
      window.ipcRenderer.invoke(MINIUMIZE);
    },
    async maximumize() {
      await window.ipcRenderer.invoke(QUIT);
    },
  };
}
